import {
  Box,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import moment from 'moment';
import { Link } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { INotice } from '../../Types/DashvoardHomeType';

interface IProps {
  index: number;
  sNotice: INotice;
}

const NoticeTableRow = ({ sNotice, index }: IProps) => {
  const theme = useTheme();

  return (
    <TableRow hover>
      <TableCell>{index + 1}</TableCell>
      <TableCell>
        <Typography
          component={Link}
          to={`/notice/${sNotice.id}`}
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textDecoration: 'none',
            color: 'text.primary',
            fontWeight: 500,
            '&:hover': {
              color: 'primary.main',
            },
          }}
        >
          {sNotice.title
            ?.toLowerCase()
            .split(' ')
            ?.map((word) => word.charAt(0)?.toUpperCase() + word?.slice(1))
            ?.join(' ')}
        </Typography>
      </TableCell>
      <TableCell>
        {moment(sNotice.published_date).format('MMMM Do YYYY, h:mm a')}
      </TableCell>

      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Link to={`/notice/${sNotice.id}`}>
            <Tooltip title='View notice' arrow>
              <IconButton
                sx={{
                  '&:hover': {
                    background: theme.colors.primary.lighter,
                  },
                  color: theme.palette.primary.main,
                }}
                color='inherit'
                size='small'
              >
                <VisibilityIcon fontSize='small' />
              </IconButton>
            </Tooltip>
          </Link>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default NoticeTableRow;
